import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainer({ container_id }) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/move_package_group/container/${container_id}`
    );
  },
  move({container_id, package_group_id, row_position, col_position}) {
    return RequesterV1.patch(`/agro_exporter/production/uniq_final_packing_list/move_package_group/container/${container_id}/package_group/${package_group_id}/move`,
      { package_group: { row_position, col_position } })
  },
}